<section class="section section-shaped my-0 pb-5">
  <div class="container tw-py-8">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div>
          @if (form && !isLoading) {
            <div>
              <!-- View-only mode: wrap in disabled fieldset, hide submit -->
              @if (viewOnly) {
                <fieldset [disabled]="true">
                  <app-dynamic-form [dynamicForm]="form" [submitText]="''" [disableSubmit]="true">
                  </app-dynamic-form>
                </fieldset>
              }
              <!-- Editable mode: normal form with submit -->
              @if (!viewOnly) {
                <div>
                    <app-dynamic-form [dynamicForm]="form"
                                      [submitText]="'common.submit' | translate"
                                      (submitForm)="submit($event)"
                                      (subFormTriggered)="onSubFormTriggered($event)">
                    </app-dynamic-form>
                </div>
              }
            </div>
          } @else {
            <agmo-loading></agmo-loading>
          }
        </div>

        <div
          class="text-primary text-underline cursor-pointer back-button h5 tw-mt-5 tw-text-center"
          (click)="back()"
        >
          {{ 'common.back' | translate }}
        </div>
      </div>
    </div>
  </div>
</section>
